import { PrintersApiService } from './api/printers-api.service';
import { PaydesksApiService } from './api/paydesks-api.service';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { Cookie } from 'ng2-cookies/cookie';
import { AdminAgenciesApiService } from './api/admin-agencies-api.service';
import { AdminReservationApiService } from './api/admin-reservation-api.service';
import { AdminPromosApiService } from './api/admin-promos-api.service';
import { AgenciesApiService } from './api/agencies-api.service';
import { AgentApiService } from './api/agent-api.service';
import { ApiService } from './api/api.service';
import { AuthenticatedApiService } from './api/authenticated-api.service';
import { CompaniesApiService } from './api/companies-api.service';
import { CompanyUsersApiService } from './api/company-users-api.service';
import { CostCentersApiService } from './api/cost-centers-api.service';
import { CreditCardsApiService } from './api/credit-cards-api.service';
import { InvoicesApiService } from './api/invoices-api.service';
import { AdminCompaniesApiService } from './api/admin-companies-api.service';
import { PaymentMethodApiService } from './api/payment-methods-api.service';
import { ProductsApiService } from './api/products-api.service';
import { AdminProductsApiService } from './api/admin-products-api.service';
import { ProfilesApiService } from './api/profiles-api.service';
import { ReservationsApiService } from './api/reservations-api.service';
import { AdminClientsApiService } from './api/admin-clients-api.service';
import { AdminUsersApiService } from './api/adminUsers-api.service';
import { ShuttleApiService } from './api/shuttle-api.service';
import { VehiclesApiService } from './api/vehicles-api.service';
import { ReservationBuilder } from './builders/reservation-builder';
import { RESTClientConfig } from './config';
import { AuthenticationService } from './services/authentication.service';
import { UsersApiService } from './api/users-api.service';
import { SpaceApiService } from './api/space-api.service';
import { AdminInvoiceProfileApiService } from './api/admin-invoice-profile.service';
import { AdminStocksApiService } from './api/admin-stocks-api.service';
import { AdminLotsApiService } from './api/admin-lots-api.service';
import { AdminInvoiceApiService } from './api/admin-invoice-api.service';
import { AdminOcupationApiService } from './api/admin-ocupation-api.service';
import { AdminMechanicalOrderApiService } from './api/admin-mechanical-order-api.service';
import { AdminApiService } from './api/admin-api.service';
import { AdminPaymentsApiService } from './api/admin-payments-api.service';
import { AdminExtrasApiService } from './api/admin-extras-api.service';
import { AdminPermissionsApiService } from './api/admin-permissions-api.service';
import { AdminPermissionsGroupApiService } from './api/admin-permissions-group-api.service';
import { AdminPlacesApiService } from './api/admin-places-api.service';
import { AdminCitiesApiService } from './api/admin-cities-api.service';
import { AdminTerminalsApiService } from './api/admin-terminals-api.service';
import { AdminGeofencesApiService } from './api/admin-geofences-api.service';
import { AdminReservationExtraApiService } from './api/admin-reservation-extra-api.service';
import { A3LinksApiService } from './api/a3-links-api.service';
import { AdminPaymethodsApiService } from './api/admin-paymethods-api.service';
import { AdminKeyZonesApiService } from './api/admin-key-zones-api.services';
import { SurveysApiService } from './api/surveys-api.service';
import { SurveysGroupsApiService } from './api/surveys-groups-api.service';
import { GatekeeperApiService } from './api/gatekeeper-api.service';
import { CommunicationsLogsApiService } from './api/communications-logs-api.service';
import { CarServicesApiService } from './api/car-services-api.service';
import { MechanicalEstimateApiService } from './api/mechanical-estimate-api.service';
import { MechanicalOrderApiService } from './api/mechanical-order-api.service';
import { AdminWorkshopsApiService } from './api/admin-workshops-api.service';
import * as i0 from "@angular/core";
export { RESTClientConfig } from './config';
export { AgentApiService } from './api/agent-api.service';
export { AuthenticationService } from './services/authentication.service';
export { ApiService } from './api/api.service';
export { AuthenticatedApiService } from './api/authenticated-api.service';
export { CompaniesApiService } from './api/companies-api.service';
export { AgenciesApiService } from './api/agencies-api.service';
export { CostCentersApiService } from './api/cost-centers-api.service';
export { CreditCardsApiService } from './api/credit-cards-api.service';
export { InvoicesApiService } from './api/invoices-api.service';
export { PaymentMethodApiService } from './api/payment-methods-api.service';
export { ProductsApiService } from './api/products-api.service';
export { AdminProductsApiService } from './api/admin-products-api.service';
export { ProfilesApiService } from './api/profiles-api.service';
export { ReservationsApiService } from './api/reservations-api.service';
export { AdminClientsApiService } from './api/admin-clients-api.service';
export { AdminUsersApiService } from './api/adminUsers-api.service';
export { ShuttleApiService } from './api/shuttle-api.service';
export { VehiclesApiService } from './api/vehicles-api.service';
export { AdminAgenciesApiService } from './api/admin-agencies-api.service';
export { AdminReservationApiService } from './api/admin-reservation-api.service';
export { AdminCompaniesApiService } from './api/admin-companies-api.service';
export { AdminPromosApiService } from './api/admin-promos-api.service';
export { SpaceApiService } from './api/space-api.service';
export { AdminInvoiceProfileApiService } from './api/admin-invoice-profile.service';
export { AdminLotsApiService } from './api/admin-lots-api.service';
export { AdminOcupationApiService } from './api/admin-ocupation-api.service';
export { AdminMechanicalOrderApiService } from './api/admin-mechanical-order-api.service';
export { AdminApiService } from './api/admin-api.service';
export { AdminPaymentsApiService } from './api/admin-payments-api.service';
export { AdminExtrasApiService } from './api/admin-extras-api.service';
export { AdminPermissionsApiService } from './api/admin-permissions-api.service';
export { AdminPermissionsGroupApiService } from './api/admin-permissions-group-api.service';
export { AdminPlacesApiService } from './api/admin-places-api.service';
export { AdminCitiesApiService } from './api/admin-cities-api.service';
export { AdminTerminalsApiService } from './api/admin-terminals-api.service';
export { AdminGeofencesApiService } from './api/admin-geofences-api.service';
export { AdminReservationExtraApiService } from './api/admin-reservation-extra-api.service';
export { A3LinksApiService } from './api/a3-links-api.service';
export { AdminPaymethodsApiService } from './api/admin-paymethods-api.service';
export { SurveysApiService } from './api/surveys-api.service';
export { SurveysGroupsApiService } from './api/surveys-groups-api.service';
export { CommunicationsLogsApiService } from './api/communications-logs-api.service';
export { CarServicesApiService } from './api/car-services-api.service';
export { MechanicalEstimateApiService } from './api/mechanical-estimate-api.service';
export { MechanicalOrderApiService } from './api/mechanical-order-api.service';
export { AdminWorkshopsApiService } from './api/admin-workshops-api.service';
export function configFactory() {
    return new RESTClientConfig(null);
}
export function getAuthToken(useCookies, tokenKey) {
    const key = tokenKey || 'auth_token';
    const cookieData = Cookie.get(key);
    const localStoreData = localStorage.getItem(key);
    let res = null;
    if (useCookies) {
        res = cookieData ? cookieData : localStoreData;
    }
    else {
        res = localStoreData ? localStoreData : cookieData;
    }
    if (res) {
        if (localStoreData != res) {
            localStorage.setItem(key, res);
        }
        if (cookieData != res) {
            Cookie.set(tokenKey, JSON.stringify(res), 365, '/');
        }
    }
    try {
        if (res) {
            return JSON.parse(res);
        }
        else {
            return null;
        }
    }
    catch (e) {
        console.log("invalid token.");
        localStorage.removeItem(key);
        return null;
    }
}
export function setAuthToken(useCookies, token, tokenKey) {
    const key = tokenKey || 'auth_token';
    Cookie.set(tokenKey, JSON.stringify(token), 365, '/');
    return localStorage.setItem(key, JSON.stringify(token));
}
export function deleteAuthToken(useCookies, tokenKey) {
    const key = tokenKey || 'auth_token';
    Cookie.delete(key, '/');
    return localStorage.removeItem(key);
}
export function authenticationServiceFactory(api, restClientConfig) {
    return new AuthenticationService({
        tokenGetter: getAuthToken,
        tokenSetter: setAuthToken,
        tokenDeleter: deleteAuthToken
    }, api, restClientConfig);
}
export class RESTClientModule {
}
RESTClientModule.ɵmod = i0.ɵɵdefineNgModule({ type: RESTClientModule });
RESTClientModule.ɵinj = i0.ɵɵdefineInjector({ factory: function RESTClientModule_Factory(t) { return new (t || RESTClientModule)(); }, providers: [
        {
            provide: RESTClientConfig,
            useFactory: configFactory
        },
        {
            provide: AuthenticationService,
            useFactory: authenticationServiceFactory,
            deps: [ApiService, RESTClientConfig]
        },
        ApiService,
        CompaniesApiService,
        AgenciesApiService,
        CompanyUsersApiService,
        CostCentersApiService,
        CreditCardsApiService,
        InvoicesApiService,
        AdminCompaniesApiService,
        PaymentMethodApiService,
        ProductsApiService,
        AdminProductsApiService,
        ProfilesApiService,
        ReservationsApiService,
        UsersApiService,
        AdminClientsApiService,
        AdminUsersApiService,
        ShuttleApiService,
        VehiclesApiService,
        AuthenticatedApiService,
        ReservationBuilder,
        AgentApiService,
        AdminAgenciesApiService,
        AdminReservationApiService,
        AdminPromosApiService,
        AdminReservationApiService,
        SpaceApiService,
        AdminLotsApiService,
        AgentApiService,
        AdminInvoiceProfileApiService,
        AdminInvoiceApiService,
        AdminStocksApiService,
        AdminOcupationApiService,
        AdminMechanicalOrderApiService,
        AdminApiService,
        AdminPaymentsApiService,
        AdminExtrasApiService,
        AdminPermissionsApiService,
        AdminPermissionsGroupApiService,
        AdminPlacesApiService,
        AdminCitiesApiService,
        AdminTerminalsApiService,
        AdminGeofencesApiService,
        AdminReservationExtraApiService,
        PaydesksApiService,
        PrintersApiService,
        A3LinksApiService,
        AdminPaymethodsApiService,
        AdminKeyZonesApiService,
        SurveysApiService,
        SurveysGroupsApiService,
        GatekeeperApiService,
        CommunicationsLogsApiService,
        CarServicesApiService,
        MechanicalEstimateApiService,
        MechanicalOrderApiService,
        AdminWorkshopsApiService
    ], imports: [[
            HttpClientModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(RESTClientModule, { imports: [HttpClientModule] }); })();
(function () { i0.ɵsetClassMetadata(RESTClientModule, [{
        type: NgModule,
        args: [{
                imports: [
                    HttpClientModule
                ],
                providers: [
                    {
                        provide: RESTClientConfig,
                        useFactory: configFactory
                    },
                    {
                        provide: AuthenticationService,
                        useFactory: authenticationServiceFactory,
                        deps: [ApiService, RESTClientConfig]
                    },
                    ApiService,
                    CompaniesApiService,
                    AgenciesApiService,
                    CompanyUsersApiService,
                    CostCentersApiService,
                    CreditCardsApiService,
                    InvoicesApiService,
                    AdminCompaniesApiService,
                    PaymentMethodApiService,
                    ProductsApiService,
                    AdminProductsApiService,
                    ProfilesApiService,
                    ReservationsApiService,
                    UsersApiService,
                    AdminClientsApiService,
                    AdminUsersApiService,
                    ShuttleApiService,
                    VehiclesApiService,
                    AuthenticatedApiService,
                    ReservationBuilder,
                    AgentApiService,
                    AdminAgenciesApiService,
                    AdminReservationApiService,
                    AdminPromosApiService,
                    AdminReservationApiService,
                    SpaceApiService,
                    AdminLotsApiService,
                    AgentApiService,
                    AdminInvoiceProfileApiService,
                    AdminInvoiceApiService,
                    AdminStocksApiService,
                    AdminOcupationApiService,
                    AdminMechanicalOrderApiService,
                    AdminApiService,
                    AdminPaymentsApiService,
                    AdminExtrasApiService,
                    AdminPermissionsApiService,
                    AdminPermissionsGroupApiService,
                    AdminPlacesApiService,
                    AdminCitiesApiService,
                    AdminTerminalsApiService,
                    AdminGeofencesApiService,
                    AdminReservationExtraApiService,
                    PaydesksApiService,
                    PrintersApiService,
                    A3LinksApiService,
                    AdminPaymethodsApiService,
                    AdminKeyZonesApiService,
                    SurveysApiService,
                    SurveysGroupsApiService,
                    GatekeeperApiService,
                    CommunicationsLogsApiService,
                    CarServicesApiService,
                    MechanicalEstimateApiService,
                    MechanicalOrderApiService,
                    AdminWorkshopsApiService
                ],
                exports: []
            }]
    }], null, null); })();
//# sourceMappingURL=rest-client.module.js.map